import axios, {AxiosResponse} from 'axios'
import {NotificationListModel, NotificationModel} from '../models/NotificationModels'

const AUTH_API_URL = process.env.REACT_APP_AUTH_API_URL

export const CONTROLLER_URL = `${AUTH_API_URL}/Notifications`

export const GetNotificationList = (displayCount:number):Promise<NotificationListModel> =>{
  return axios.get(`${CONTROLLER_URL}/GetNotificationList/${displayCount}`).then((response: AxiosResponse<NotificationListModel>) => response.data)
}

export const MarkAsRead = (id: number):Promise<NotificationModel> =>{
    return axios.get(`${CONTROLLER_URL}/MarkAsRead/${id}`).then((response: AxiosResponse<NotificationModel>) => response.data)
}